import { computed, type ComputedRef, type Ref } from "vue";

type BooleanSource = Readonly<Ref<boolean>>;
type OptionalBooleanSource = Readonly<Ref<boolean | undefined>>;

interface UseAnnotationAccessParams {
  isTeacherView: BooleanSource;
  isTeacherStudentView: BooleanSource;
  isAttemptableSession: BooleanSource;
  isFromAlsAdaptiveSection: BooleanSource;
  resourceToBeMarked: BooleanSource;
  visibleByStudents: OptionalBooleanSource;
}

interface AnnotationAccess {
  showVisibleByStudentOptions: ComputedRef<boolean>;
  isAlsSection: ComputedRef<boolean>;
  showNotifyStudents: ComputedRef<boolean>;
  disableNotifyStudents: ComputedRef<boolean>;
}

export function useAnnotationAccess(params: UseAnnotationAccessParams): AnnotationAccess {
  const showVisibleByStudentOptions = computed(() => params.isTeacherView.value);

  const isAlsSection = computed(
    () => params.isAttemptableSession.value || params.isFromAlsAdaptiveSection.value,
  );

  const showNotifyStudents = computed(() => {
    if (isAlsSection.value) {
      return false;
    }

    if (params.isTeacherStudentView.value) {
      return !params.resourceToBeMarked.value;
    }

    return showVisibleByStudentOptions.value;
  });

  const disableNotifyStudents = computed(() => {
    if (showVisibleByStudentOptions.value) {
      return !params.visibleByStudents.value;
    }

    return false;
  });

  return {
    showVisibleByStudentOptions,
    isAlsSection,
    showNotifyStudents,
    disableNotifyStudents,
  };
}
